<template>
  <div class="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-5">
    <div v-for="(item, index) in length" :key="index"
         class="bg-white dark:bg-slate-800 p-4 relative z-[1] rounded-2xl text-white flex flex-col justify-between overflow-hidden cursor-pointer gap-4"
    >
      <div class="animate-pulse">
        <div class="w-full">
          <div class="dir-ltr flex flex-row justify-between mb-3 h-8">
            <div class="rounded-xl bg-[#C4C4C4] dark:bg-slate-500 h-8"
                 :class="`${hasState ? 'w-[60%]' : 'w-full'}`"></div>
            <div v-if="hasState"
                 class="w-[20%] rounded-full bg-[#C4C4C4] dark:bg-slate-500 h-8">

            </div>
          </div>

          <div class="rounded-full bg-[#C4C4C4] dark:bg-slate-500 h-6 mb-2">
          </div>
        </div>
        <div class="mt-6 flex flex-row justify-between">
          <div class="w-20 h-6 rounded-lg bg-lime-200">

          </div>
          <div class="w-10 h-6 rounded-full bg-[#C4C4C4] dark:bg-slate-500">

          </div>
        </div>
        <img v-if="themeSettingsStore.isDark"
             src="@/assets/images/svg/line.svg"
             alt=""
             class="absolute left-0 bottom-0 w-full z-[-1] opacity-50"
        />
        <img v-else
             src="@/assets/images/svg/line-dark.svg"
             alt=""
             class="absolute left-0 bottom-0 w-full z-[-1] opacity-50"
        />
      </div>
    </div>
  </div>
</template>
<script>
import {computed, onMounted, ref} from "vue";
import {useThemeSettingsStore} from "@/stores/themeSettings.js";

const themeSettingsStore = useThemeSettingsStore()
export default {
  props: {
    count: {
      type: Number,
      default: 6,
    },
    hasState: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const items = computed(() => Array.from({length: 6}))
    const width = ref(0);
    const length = ref(4);
    const handleResize = () => {
      width.value = window.innerWidth;
      if (width.value >= 640) {
        length.value = 4
      }
      if (width.value >= 768) {
        length.value = 6
      }
      if (width.value >= 1024) {
        length.value = 8
      }
    };
    onMounted(() => {
      window.addEventListener("resize", handleResize);
      handleResize();
    });
    return {
      length,
      themeSettingsStore
    }
  }
};
</script>
<style scoped lang="scss">
.dir-ltr {
  direction: ltr;
}

.dir-rtl {
  direction: rtl;
}
</style>
